import { render, staticRenderFns } from "./SocialConfigFeedComponent.vue?vue&type=template&id=be931804&"
import script from "./SocialConfigFeedComponent.vue?vue&type=script&lang=js&"
export * from "./SocialConfigFeedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports